export const SUGGEST_DEBOUNCE_MS = 320;
export const TRANSACTION_ID_MAX_LENGTH = 20;

const DAY_MS = 24 * 60 * 60 * 1000;

export function formatDisplayDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatMoney(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(n);
}

export function slotsLabel(t) {
  const max = t.max_students_allowed;
  if (max == null || Number(max) <= 0) return "Unlimited";
  const avail = t.available_slots;
  if (avail == null) return "—";
  return String(avail);
}

export function isTournamentFull(t) {
  const max = t.max_students_allowed;
  if (max == null || Number(max) <= 0) return false;
  return Number(t.available_slots) === 0;
}

export function selectedStudentDisplayLabel(student) {
  if (!student) return "";
  const codePart = student.code ? ` (${student.code})` : "";
  return `${student.full_name || ""}${codePart}`.trim();
}

function startOfDayTimestamp(value) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

export function tournamentStatusByRegistrationClosingDate(tournament) {
  const todayTs = startOfDayTimestamp(new Date());
  const closeTs = startOfDayTimestamp(tournament?.registration_last_date);
  const eventTs = startOfDayTimestamp(tournament?.tournament_date);
  if (todayTs == null) {
    return { key: "upcoming", badge: "U", label: "Upcoming", canRegister: true };
  }
  if (eventTs != null && eventTs <= todayTs) {
    return { key: "ongoing", badge: "O", label: "Ongoing", canRegister: false };
  }
  if (closeTs == null) {
    return { key: "upcoming", badge: "U", label: "Upcoming", canRegister: true };
  }
  const daysUntilClose = Math.floor((closeTs - todayTs) / DAY_MS);
  if (daysUntilClose <= 1) {
    return { key: "closing_1d", badge: "U", label: "Closing in 1 day", canRegister: true };
  }
  if (daysUntilClose <= 2) {
    return { key: "closing_2d", badge: "U", label: "Closing in 2 days", canRegister: true };
  }
  return { key: "upcoming", badge: "U", label: "Upcoming", canRegister: true };
}
